export default "__VITE_ASSET__CxB4uaDu__"